import { ITypedReduxAction } from '../../../common/types/redux';

export enum ERulerActionType {
  RulerEnabled = 'RULER/ENABLED',
  RulerDisabled = 'RULER/DISABLED',
}

export type TRulerEnabledAction = ITypedReduxAction<ERulerActionType.RulerEnabled>;
export type TRulerDisabledAction = ITypedReduxAction<ERulerActionType.RulerDisabled>;

export type TRulerActions = TRulerEnabledAction | TRulerDisabledAction;
